
import React, { useState, useEffect } from "react";


const Footer = () => {

return (
<>


    <footer className="footer">
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                <p className="footer-para">© 2025 SpotSaver. All rights reserved.</p>
                </div>
              
            </div>
        </div>
    </footer>


</>
);
};

export default Footer;